import type { UiState } from './types';

const defaultState: UiState = {};

// TODO: replace "action: any" with propper type as soon as there is any UI-related action
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (state: UiState = defaultState, action: any): UiState => {
	switch (action.type) {
		default: {
			return state;
		}
	}
};
